import { Chip } from '@mui/material'
import { type Color } from 'src/types'


type OptionButtonProps = {
  text: string
  color: Color
  backgroundColor: string
  borderColor: string
  handleClick: (arg0: any) => any
}

const OptionButton = ({ text, handleClick, color, backgroundColor, borderColor }: OptionButtonProps) => (
  <Chip
    label={text}
    sx={{
      color,
      border: `1px solid ${borderColor}`,
      backgroundColor,
      '&:hover': {
        backgroundColor: color,
        color: backgroundColor
      }
    }}
    onClick={handleClick}
    className="option"
  />
)

export default OptionButton
